import { createUuid } from "../../../lib/trace/context";
import { isHttpClientError } from "../../../lib/http/errors";

/** 当前分享授权和打开流程允许展示的错误信息。 */
export const shareErrorMessages: Record<string, string> = {
  share_not_found: "分享不存在，请检查链接是否完整，或联系分享人获取新链接。",
  share_revoked: "该分享已被撤销，请联系分享人重新分享。",
  share_expired: "该分享已过期，请联系分享人获取新链接。",
  oauth_not_configured: "微信授权暂未配置，请联系分享人。",
  oauth_denied: "微信授权未完成，请重新打开分享并同意授权。",
  oauth_code_invalid: "微信授权已失效，请重新打开分享。",
  oauth_userinfo_failed: "暂时无法取得微信资料，请稍后重新打开分享。",
  oauth_state_invalid: "授权会话已失效，请在当前浏览器重新打开原分享链接。",
  oauth_unavailable: "微信授权服务暂时不可用，请稍后重试。",
  oauth_required: "请先完成微信授权后查看分享。",
  oauth_origin_invalid: "当前访问来源不受信任，请从原分享链接重新打开。",
};

/** 判断服务端返回的分享失效错误码。 */
export function shareErrorCode(error: unknown): string | undefined {
  if (isHttpClientError(error) && error.code && shareErrorMessages[error.code]) return error.code;
  return undefined;
}

/** 创建一次页面打开的稳定事件 ID。 */
export function createShareOpenEventId(): string { return createUuid(); }

/** 将回跳 query 中的错误转换为稳定客户提示。 */
export function shareErrorMessage(code?: string | null): string | undefined {
  return code ? shareErrorMessages[code] : undefined;
}
